import Modal from '@oncolens/oncolens-ui/lib/components/Common/Modal';
import { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import OncolensToast from '@/components/Elements/Toast/Toast';
import { deleteEpisode } from '../hooks/useEpisode';
import useRequestFormStore from '../store';

interface DeleteDiseaseEpisodeModalProps {
	diseaseId: string;
	episodeId: string;
}

const DeleteDiseaseEpisodeModal = ({ diseaseId, episodeId }: DeleteDiseaseEpisodeModalProps) => {
  const [modalState, setModalState] = useState({ isLoading: false, showModal: false });
  const updateStore = useRequestFormStore((store) => store.updateStore);
  const handleDelete = () => {
    setModalState((state) => ({ ...state, isLoading: true }));

    deleteEpisode(episodeId)
      .then(() => {
        updateStore((store) => {
          delete store.diseases[diseaseId].episodes[episodeId];
        });
        setModalState({ showModal: false, isLoading: false });
        OncolensToast.success('History removed successfully.');
      })
      .catch(() => {
        setModalState((state) => ({ ...state, isLoading: false }));
        OncolensToast.error('There was an error removing the history item. Try again.');
      });
  };

  return (
    <Modal
      show={modalState.showModal}
      triggerElement={
        <FaTrash className="box-content col-start-2 p-2 ml-auto text-gray-600 transition-colors duration-200 cursor-pointer hover:text-gray-800" />
      }
    >
      <Modal.Header title="Delete History" showClose={true} />
      <Modal.Content>
        <p>
					Deleting this history will remove all the staging, biomarkers and risk & prognostic
					factors that have been entered for this history episode. Are you sure?
        </p>
      </Modal.Content>
      <Modal.Buttons
        buttons={[
          {
            label: 'Cancel',
            style: 'secondary',
            color: 'gray',
            closeAfterClick: true,
            className: 'w-auto inline-block ml-auto mr-2 px-4'
          },
          {
            label: 'Delete',
            style: 'primary',
            color: 'red',
            loading: modalState.isLoading,
            useLoading: true,
            onClick: handleDelete,
            closeAfterClick: false,
            className: 'w-auto inline-block px-4'
          }
        ]}
      />
    </Modal>
  );
};

export { DeleteDiseaseEpisodeModal as default };
